/* Packages */
import React from "react";
import TextField from "@webstores/webstores-configurator/dist/inputs/TextField";
import TextArea from "@webstores/webstores-configurator/dist/inputs/TextArea";
import CheckboxList from "@webstores/webstores-configurator/dist/inputs/CheckboxList";
import DropdownSelect from "@webstores/webstores-configurator/dist/inputs/DropdownSelect";
import DateField from '@webstores/webstores-configurator/dist/inputs/DateField';

/* Components */
import {Button} from '../../common';

export default function ConversionDetails({
    stepData,
    setStepData,
    title,
    isLoading
}) {
    /* Constants */
    const { inputs } = stepData;

    /* Render */
    return (
        <>
            <h3 className="h2 mb-6 mb-lg-10">{title}</h3>
            <div className="row gutters-3 gutters-xl-6">
                {Object.keys(inputs).map((key, keyIndex) => {
                    const input = inputs[key];
                    const {type, label, name, required, width} = input;

                    if (type === 'text') {
                        return (
                            <div key={keyIndex} className={`col col-12 col-lg-${width}`}>
                                <label htmlFor={`product-${name}`}>
                                    {label} {required && "*"}
                                </label>
                                <TextField
                                    id={`product-${name}`}
                                    className="form-control"
                                    input={input}
                                    stepData={stepData}
                                    setStepData={setStepData}
                                    field={`inputs.${name}`}
                                />
                            </div>
                        );
                    }

                    if (type === 'email') {
                        return (
                            <div key={keyIndex} className={`col col-12 col-lg-${width}`}>
                                <label htmlFor={`product-${name}`}>
                                    {label} {required && "*"}
                                </label>
                                <TextField
                                    id={`product-${name}`}
                                    className="form-control"
                                    input={input}
                                    inputMode={name}
                                    stepData={stepData}
                                    setStepData={setStepData}
                                    field={`inputs.${name}`}
                                />
                            </div>
                        );
                    }

                    if (type === 'phone') {
                        return (
                            <div key={keyIndex} className={`col col-12 col-lg-${width}`}>
                                <label htmlFor={`product-${name}`}>
                                    {label} {required && "*"}
                                </label>
                                <TextField
                                    id={`product-${name}`}
                                    className="form-control"
                                    input={input}
                                    inputMode={name}
                                    stepData={stepData}
                                    setStepData={setStepData}
                                    field={`inputs.${name}`}
                                />
                            </div>
                        );
                    }

                    if (type === 'textarea') {
						return (
                            <div key={keyIndex} className={`col col-12 col-lg-${width}`}>
                                <label htmlFor={`product-${name}`}>
                                    {label} {required && "*"}
                                </label>
                                <TextArea
                                    id={`product-${name}`}
                                    className="form-control"
                                    input={input}
                                    stepData={stepData}
                                    setStepData={setStepData}
                                    field={`inputs.${name}`}
                                />
                            </div>
						);
					}

                    if (type === 'checkbox-list') {
                        return (
                            <div key={keyIndex} className={`col col-12 col-lg-${width}`}>
                                <label className="d-block" htmlFor={`product-${name}`}>
                                    {label} {required && "*"}
                                </label>
                                <CheckboxList
                                    id={`product-${name}`}
                                    className="custom-control custom-control--inline custom-checkbox"
                                    inputClassName="custom-control-input"
                                    labelClassName="custom-control-label"
                                    input={input}
                                    stepData={stepData}
                                    setStepData={setStepData}
                                    preventUpdate={false}
                                    field={`inputs.${name}`}
                                />
                            </div>
                        );
                    }

                    if (type === 'select') {
                        return (
                            <div key={keyIndex} className={`col col-12 col-lg-${width}`}>
                                <label htmlFor={`product-${name}`}>
                                    {label} {required && "*"}
                                </label>
                                <DropdownSelect
                                    id={`product-${name}`}
                                    className="form-control custom-select"
                                    input={input}
                                    stepData={stepData}
                                    setStepData={setStepData}
                                    preventUpdate={true}
                                    field={`inputs.${name}`}
                                />
                            </div>
                        );
                    }

                    if (type === 'date') {
                        return (
                            <div key={keyIndex} className={`col col-12 col-lg-${width}`}>
                                <label className="d-block" htmlFor={`product-${name}`}>
                                    {label} {required && "*"}
                                </label>
                                <DateField
                                    id={`product-${name}`}
                                    className="form-control form-control--date"
                                    input={input}
                                    stepData={stepData}
                                    setStepData={setStepData}
                                    field={`inputs.${name}`}
                                    dateFormat="dd-MM-yyyy"
                                    filterDate={(date) => {
                                        const day = date.getDay();
                                        return day !== 0;
                                    }}
                                />
                            </div>
                        );
                    }
                })}
                <div className="col-12 col-lg-auto">
                    <Button
                        classes="btn-block mt-lg-4"
                        type="submit"
                        linkTitle="Aanvraag verzenden"
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </>
    );
}
